import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CallService, CallData } from './services/call.service';
import { VideoCallComponent } from './components/video-call/video-call.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    VideoCallComponent,
    // Thêm các module khác nếu template dùng
  ]
})
export class AppComponent implements OnInit {
  isCallActive: boolean = false;
  currentCallData: CallData | null = null;

  constructor(private callService: CallService) {}

  ngOnInit() {
    // Subscribe to call state changes
    this.callService.callActive$.subscribe(active => {
      console.log('Call active state changed:', active);
      this.isCallActive = active;
    });
    
    // Subscribe to call data changes
    this.callService.callData$.subscribe(callData => {
      this.currentCallData = callData;
    });
  }

  onCallEnded() {
    this.callService.endCall();
  }
}
